import React from 'react'
import { withRouter } from 'react-router-dom'

export default function withLanguage (Component) {
    const ComponentWithLanguage = props => {
        const language = new URLSearchParams(window.location.search).get("language")
        const params = new URLSearchParams()
        params.set("language", language)
        const languageQuery =  params.toString()
      return (
        <Component
          {...props}
          language={language}
          languageQuery={languageQuery}
        />
      )
    }  
    return withRouter(ComponentWithLanguage);
  }


// WEBPACK FOOTER //
// ./src/HOCs/withLanguage.js